var ArticleSubtitle = function ArticleSubtitle() {
  return /*#__PURE__*/React.createElement("div", {
    className: "a__btm-border"
  });
};
export default ArticleSubtitle;